var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnReportEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 48,
    viewBox: "0 0 83 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7684 0C60.3542 0 60.0184 0.335786 60.0184 0.75C60.0184 1.16421 60.3542 1.5 60.7684 1.5H68.3919L50.2936 17.5697L33.0482 9.67214C32.8158 9.56572 32.5452 9.58496 32.3303 9.72321L7.14878 25.9164C6.80038 26.1404 6.69957 26.6045 6.92361 26.9529C7.14765 27.3013 7.6117 27.4021 7.9601 27.178L32.7966 11.2067L50.1137 19.1371C50.3839 19.2608 50.7017 19.2134 50.9239 19.016L69.5334 2.49235V9.91422C69.5334 10.3284 69.8692 10.6642 70.2834 10.6642C70.6976 10.6642 71.0334 10.3284 71.0334 9.91422V0.75C71.0334 0.335786 70.6976 0 70.2834 0H60.7684ZM63.301 16.9817H64.051H74.7621H75.5121V17.7317V46.4996H83V47.9996H0V46.4996H8.65698V35.666V34.916H9.40698H20.1181H20.8681V35.666V46.4157H19.3681V36.416H10.157V46.4996H26.3921V24.3757V23.6257H27.1421H37.8532H38.6032V24.3757V46.4996H45.5029V28.0415V27.2915H46.2529H56.9641H57.7141V28.0415V46.4996H63.301V17.7317V16.9817ZM37.1032 46.4996H27.8921V25.1257H37.1032V46.4996ZM56.2141 46.4996V28.7915H47.0029V46.4996H56.2141ZM74.0121 18.4817V46.4996H64.801V18.4817H74.0121Z",
    fill: "#A3A3AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnReportEmpty);
export default __webpack_public_path__ + "static/media/icn-report-empty.d2a79fd7.svg";
export { ForwardRef as ReactComponent };